import * as React from 'react';
import { UseFormReturn } from 'react-hook-form';

import { cn } from 'utils/cn';

import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from './form';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
    return (
        <textarea
            className={cn(
                'border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring flex min-h-[80px] w-full rounded-md border px-3 py-2 text-sm focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
                className,
            )}
            ref={ref}
            {...props}
        />
    );
});
Textarea.displayName = 'Textarea';

interface FormTextareaProps {
    formMethods: UseFormReturn<any, any, any>;
    name: string;
    label?: string;
    placeholder?: string;
    description?: string;
    defaultValue?: string;
    rows?: number;
    required?: boolean;
}

const FormTextarea = (props: FormTextareaProps) => {
    return (
        <FormField
            defaultValue={props.defaultValue ?? ''}
            control={props.formMethods.control}
            name={props.name}
            render={({ field }) => (
                <FormItem className="flex flex-col gap-2">
                    {props.label && <FormLabel>{props.label}</FormLabel>}
                    <FormControl>
                        <Textarea
                            {...field}
                            placeholder={props.placeholder}
                            rows={props.rows ?? 5}
                            required={props.required}
                        />
                    </FormControl>
                    {props.description && <FormDescription>{props.description}</FormDescription>}
                    <FormMessage />
                </FormItem>
            )}
        />
    );
};

FormTextarea.displayName = 'FormTextarea';

export { Textarea, FormTextarea };
